import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  withStyles,
  TableCell,
  TableBody,
  Button,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
  getEvaluationMasterData,
  getGradingCourseDetails,
} from '../../../../../../Utils/apiServices';
import KenDialogBox from '../../../../../../global_components/KenDialogBox';
import GradingComponent from '../GradingComponent';
import '../../../../../../style/index.css';
const StyledTableCell = withStyles((theme) => ({}))(TableCell);
const StyledTableRow = withStyles((theme) => ({}))(TableRow);

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    height: '28px',
    width: '78px',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'orange',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    height: '23px',

    '&:hover': {
      color: 'white',
      background: 'orange',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '70%',
  },
  normal: {
    color: 'white',
    background: 'green',
    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',
    margin: '5px 5px',
    '&:hover': {
      background: 'green',

      color: 'white',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '70%',
  },
  editbtn: {
    color: '##272727',

    background: '#55b0cd',

    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',

    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: '##272727',
    },
    // color: '#FFFFFF',
    // background: '##272727',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '100px',
  },
  Blue: {
    color: '#FFFFFF',
    background: '##272727',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  medium: {
    color: '#f17100',
    background: 'blue',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    height: '23px',

    '&:hover': {
      background: 'blue',
      color: '#f17100',
    },
    // color: '#FFFFFF',
    // background: '#F2994A',
    // width: '70%',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
  table: {
    minWidth: 700,
    padding: 10,
  },
  tbCourseTerm: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '100%',
    color: '#02195E',
  },
  status: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    color: '#FFFFFF',
    borderRadius: '18px',
    padding: '8px 20px',
  },
  viewEditBtn: {
    // background: "#03248F",
    borderRadius: '18px',
    padding: '8px 20px',
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  publishBtn: {
    background: '#979797',
    borderRadius: '18px',
    padding: '8px 20px',
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  normal: {
    // color: '#505F79',
    color: 'white',

    background: 'green',
    // background: '#27AE60',

    // background: 'white',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    height: '23px',
    width: '115px',

    '&:hover': {
      background: 'green',

      color: 'white',
      // border: '1px solid white',
    },
  },
  medium: {
    color: '#f17100',
    background: '#55b0cd',
    textDecoration: 'none',

    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '115px',
    height: '23px',

    '&:hover': {
      background: '#55b0cd',
      color: '#f17100',
    },
  },
  error: {
    // color: '#F14B2D',

    background: 'orange',
    // background: 'white',
    // background: '#EB5757',

    borderRadius: '25px',
    // border: '1px solid white',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: 'white',
    height: '23px',
    width: '115px',

    '&:hover': {
      color: 'white',
      background: 'orange',

      // color: 'white',
      // borderBottom: '#F14B2D',
    },
  },
  view: {
    color: '##272727',

    background: '#55b0cd',

    borderRadius: '20px',
    fontSize: '10px',

    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: '##272727',
    },
  },
  publishView: {
    color: '#505F79',
    background: '#55b0cd',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: '#505F79',
    },
  },
}));
const CourseGrading = () => {
  const classes = useStyles();

  const [course, setCourse] = useState([]);
  const [sliderDialog, setSliderDialog] = useState(false);
  const [CourseName, setCourseName] = useState();

  function handleSliderDialog(ele) {
    setSliderDialog((prevState) => !prevState);

    setCourseName(ele);
  }

  const handleClickSlider = () => {
    handleSliderDialog();
  };

  function positiveClick() {
    setSliderDialog((prevState) => !prevState);
  }
  const getGradingData = () => {
    let filterData = {
      term: '',
      course: '',
      campus: '',
      subjectFaculty: '',
      status: '',
      examCycle: '',
      batch: '',
    };
    getGradingCourseDetails(filterData)
      .then((res) => {
        console.log('getGradingCourseDetails', res);
        if (res !== null) {
          setCourse(res);
        }
      })
      .catch((err) => {
        console.log('Grading Course Details error', err);
      });
  };

  const [evaluationMasterData, setEvaluationMasterData] = useState([]);

  useEffect(() => {
    let gradingId = 'a196D000000gcCSQAY';
    getEvaluationMasterData()
      .then((res) => {
        if (CourseName === res) {
        }
        setEvaluationMasterData(res);
      })
      .catch((err) => {
        console.log('Evaluation Master Data API', err);
      });
    getGradingData();
  }, []);
  return (
    <div>
      {' '}
      <TableContainer
        component={Paper}
        style={{ padding: '16px', marginTop: 16 }}
      >
        <Table>
          <TableHead className="tableHeader">
            <TableRow>
              <StyledTableCell align="left" className="tableHeaderTitle">
                COURSE
              </StyledTableCell>
              <StyledTableCell align="left" className="tableHeaderTitle">
                TERM
              </StyledTableCell>{' '}
              <StyledTableCell
                align="left"
                className="tableHeaderTitle"
                colSpan={1}
              >
                ACTIONS
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody className="tablebody1">
            {course?.map((ele, index) => {
              console.log('eleeleele', ele);
              return (
                <StyledTableRow key={ele?.courseName}>
                  <StyledTableCell>{ele?.courseName}</StyledTableCell>
                  <StyledTableCell>{ele?.term}</StyledTableCell>

                  <StyledTableCell>
                    <Button
                      className={classes.publishView}
                      size="small"
                      variant="primary"
                      onClick={() => handleSliderDialog(ele.id)}
                    >
                      Master component
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <KenDialogBox
        title={
          <Typography variant="p" style={{ textAlign: 'center' }}>
            GRADING COMPONENT MASTER LIST
          </Typography>
        }
        open={sliderDialog}
        handleClose={() => handleSliderDialog()}
        negativeButtonClick={() => handleSliderDialog()}
        positiveButtonClick={() => positiveClick()}
        // hidePositiveButton={true}
        // hideNegativeButton={true}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        maxWidth="md"
        dividers
      >
        {' '}
        <GradingComponent
          evaluationMasterData={evaluationMasterData}
          CourseName={CourseName}
          // postEvaluationMasterData={postEvaluationMasterData}
        />
      </KenDialogBox>
    </div>
  );
};

export default CourseGrading;
